let elements = {
  // mainImage: {
  //   imagePath: 'games/page008_game0/img/plansza.png',
  //   width: 1920,
  //   height: 1080,
  //   cssStyle: {
  //     position: 'absolute',
  //   },
  // },
  mainImage: {
    imagePath: 'games/page020_game2/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
    height: 1080,
  },
  cssStyle: {
    overflow: 'hidden',
    'overflow-y': 'hidden',
    'overflow-x': 'hidden',
  },
  /** @type {Number} domyślna szerokość inputa [px] */
  inputWidth: 100,
  /** @type {Number} domyślna wysokość inputa [px] */
  inputHeight: 80,
  /** @type {Number} domyślna szerokośc całego bloku z inputem [px]*/
  /** @type {Number} domyślna wysokość całego bloku z inputem [px]*/
  blockHeight: 50,
  /** @type {Number} domyślna szerokośc całego tekstu z inputem [px]*/
  textBlockWidth: 1200,
  /** @type {Number} domyślna wysokość całego tekstu z inputem [px]*/
  // textBlockHeight: 100,
  /** @type {String} domyślny kolor tła */
  blockBackgroundColor: 'transparent',
  /** @type {Number} domyslna wielkość czcionki */
  gameFontSize: 55,
  /** @type {Number} ile ma być wybranych elementów */
  pick: 1,
  /** @type {Boolean} czy mają byc losowane true: tak */
  shuffle: false,
  /** @type {Number} maksymalna licznba znaków */
  inputMaxLength: 5,
  /** @type {Boolean} ustawia input w tryb Case sensitive */
  // caseSensitive: true
  /** @type {Array} pozycje bloków tekstu z inputem */
  layoutItems: [
    {
      pos: {
        x: 150,
        y: 250,
      },
      blockBackgroundColor: 'transparent',
      cssStyle: {
        'justify-content': 'flex-start',
      },
    },
    {
      pos: {
        x: 150,
        y: 500,
      },
      blockBackgroundColor: 'transparent',
      cssStyle: {
        'justify-content': 'flex-start',
      },
    },
    {
      pos: {
        x: 150,
        y: 750,
      },
      blockBackgroundColor: 'transparent',
      cssStyle: {
        'justify-content': 'flex-start',
      },
    },
    {
      pos: {
        x: 1050,
        y: 250,
      },
      blockBackgroundColor: 'transparent',
      cssStyle: {
        'justify-content': 'flex-start',
      },
    },
    {
      pos: {
        x: 1050,
        y: 500,
      },
      blockBackgroundColor: 'transparent',
      cssStyle: {
        'justify-content': 'flex-start',
      },
    },
    {
      pos: {
        x: 1050,
        y: 750,
      },
      blockBackgroundColor: 'transparent',
      cssStyle: {
        'justify-content': 'flex-start',
      },
    },
  ],
  /** @type {Array} bloki tekstu z inputami oznaczonymi markerami __elem0__,__elem1__,itd. jesli jest wiecej niz 1 to opcje dla markerow ustawiane sa w tablicy markers w kolejnosci*/
  items: [
    {
      caseSensitive: true,
      shuffle: true,
      items: [
        {
          text:
            '6 <img src="' +
            require('./img/03.png') +
            '" width="100px" /> + 2  <img src="' +
            require('./img/03.png') +
            '" width="100px" /> = __elem0__' +
            ' <img src="' +
            require('./img/03.png') +
            '" width="100px" />',
          caseSensitive: true,
          correct: ['8'],
        },
        {
          text:
            '10 <img src="' +
            require('./img/02.png') +
            '" width="100px" /> + 3 <img src="' +
            require('./img/02.png') +
            '" width="100px" /> = __elem0__' +
            ' <img src="' +
            require('./img/02.png') +
            '" width="100px" />',
          caseSensitive: true,
          correct: ['13'],
        },
        {
          text:
            '8 <img src="' +
            require('./img/01.png') +
            '" width="100px" /> + 4 <img src="' +
            require('./img/01.png') +
            '" width="100px" /> = __elem0__ ' +
            ' <img src="' +
            require('./img/01.png') +
            '" width="100px" />',
          caseSensitive: true,
          markers: [
            {
              correct: ['12'],
            },
          ],
        },
        {
          text:
            '9 <img src="' +
            require('./img/00.png') +
            '" width="100px" /> – 2 <img src="' +
            require('./img/00.png') +
            '" width="100px" /> = __elem0__ ' +
            ' <img src="' +
            require('./img/00.png') +
            '" width="100px" />',
          caseSensitive: true,
          correct: ['7'],
        },
        {
          text:
            '7 <img src="' +
            require('./img/04.png') +
            '" width="100px" /> – 4 <img src="' +
            require('./img/04.png') +
            '" width="100px" /> = __elem0__ ' +
            ' <img src="' +
            require('./img/04.png') +
            '" width="100px" />',
          caseSensitive: true,
          correct: ['3'],
        },
        {
          text:
            '14 <img src="' +
            require('./img/05.png') +
            '" width="100px" /> – 5 <img src="' +
            require('./img/05.png') +
            '" width="100px" /> = __elem0__ ' +
            ' <img src="' +
            require('./img/05.png') +
            '" width="100px" />',
          caseSensitive: true,
          markers: [
            {
              caseSensitive: true,
              correct: ['9'],
            },
          ],
        },
      ],
    },
  ],
};
export default elements;
